import { error, json } from "@sveltejs/kit";
import { promises } from "fs";
import path from "path";
import { W as WORKSPACE_DIR } from "../../../../../chunks/workspace.js";
function validatePath(requestPath) {
  const normalized = path.normalize(path.join(WORKSPACE_DIR, requestPath));
  if (!normalized.startsWith(WORKSPACE_DIR)) {
    throw error(403, "Access denied: Path outside workspace directory");
  }
  return normalized;
}
const POST = async ({ request }) => {
  try {
    const { path: filePath, content } = await request.json();
    if (!filePath) {
      throw error(400, "Path is required");
    }
    if (content === void 0) {
      throw error(400, "Content is required");
    }
    const fullPath = validatePath(filePath);
    const dir = path.dirname(fullPath);
    await promises.mkdir(dir, { recursive: true });
    await promises.writeFile(fullPath, content, "utf-8");
    const stats = await promises.stat(fullPath);
    return json({
      success: true,
      path: filePath,
      size: stats.size,
      modified: stats.mtime.toISOString()
    });
  } catch (err) {
    if (err instanceof Response) throw err;
    console.error("Error writing file:", err);
    throw error(500, "Failed to write file");
  }
};
export {
  POST
};
